import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { Form, Input, Button, Row, Col, Select, message, Table, Typography, Modal, TreeSelect } from 'antd';
import { inventorySupplierSales, inventoryAddList, inventoryAddOftenList } from '../api';
import './cartForm.less';

const { Option } = Select;
const layout = { labelCol: { span: 10, }, wrapperCol: { span: 14, }, };
const columns = [
  { title: '商品图片', key: 'sale_image', dataIndex: 'sale_image', align: 'center', render: text => <img className='proposal-cart-table-product-img-min' src={text} alt='' /> },
  { title: '商品分类', key: 'category_list', dataIndex: 'category_list', align: 'center', },
  { title: 'SKU编码', key: 'in_sku_no', dataIndex: 'in_sku_no', align: 'center', },
  { title: 'RMS编码', key: 'goods_code', dataIndex: 'goods_code', align: 'center', },
  {
    title: '商品名称', key: 'goods_name', dataIndex: 'goods_name', align: 'center', render: (text, record) => {
      const { false_reason, add_cart } = record;
      return <><div>{text}</div><div><Typography.Link>{add_cart ? null : false_reason}</Typography.Link></div></>;
    }
  },
  { title: '大仓名称', key: 'supplier_name', dataIndex: 'supplier_name', align: 'center', },
  { title: '价格(元)', key: 'norms_price', dataIndex: 'norms_price', align: 'center', render: (text, record) => `${text}/${record?.unit_name}` },
];

// let baseList = [];
export const PurchaseCartProduct = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({ form }));
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [pageConfig, setPageConfig] = useState({ page: 1, page_size: 10 });
  const [selectItems, setSelectItems] = useState({ selectedRowKeys: [], selectedRows: [] });
  const [baseList, setBaseList] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const suppliersList = [{ company_id: '', company: { name: '全部' } }, ...(props?.suppliersList || [])];
  const addCartColumns = [
    { title: '大仓名称', key: 'supplier_name', dataIndex: 'supplier_name', align: 'center', },
    {
      title: '商品名称', key: 'goods_name', dataIndex: 'goods_name', align: 'center', render: (text, record) => {
        const { false_reason, add_cart } = record;
        return <><div>{text}</div><div><Typography.Link>{add_cart ? null : false_reason}</Typography.Link></div></>;
      }
    },
    { title: '价格(元)', key: 'norms_price', dataIndex: 'norms_price', align: 'center', render: (text, record) => `${text}/${record?.unit_name}` },
    {
      title: '操作', key: 'id', dataIndex: 'id', align: 'center', render: (text) => <Typography.Link onClick={() => deleteItem(text)}>移除</Typography.Link>
    }
  ];

  async function getInventorySupplierSales() {
    const { often_id } = props;
    setBaseList(calcList([...baseList, ...selectItems.selectedRows]));
    const formValues = form.getFieldsValue() || {};
    const { brand_id: brandId } = formValues;
    const brand_id = brandId ? [brandId] : brandId;
    const { data: { code, msg, data } } = await inventorySupplierSales({ ...formValues, brand_id, ...pageConfig, often_id });
    if (+code === 0) {
      const { list = [], total } = data;
      const selectedRows = list.filter(x => baseList.some(y => y.id === x.id));
      const selectedRowKeys = selectedRows.map(item => item.id);
      setSelectItems({ selectedRowKeys, selectedRows });
      setDataSource(list);
      setTotalPage(total);
    } else {
      message.error(msg);
    }
  }
  useEffect(() => {
    getInventorySupplierSales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig]);
  const onFinish = () => {
    setPageConfig({ ...pageConfig, page: 1 });
  };
  const onReset = () => {
    form.resetFields();
    setPageConfig({ ...pageConfig, page: 1 });
  };

  const tablePageChange = (page, pageSize) => {
    // setSelectItems({ selectedRowKeys: [], selectedRows: [] });
    setPageConfig({ ...pageConfig, page, page_size: pageSize });
  };
  const rowSelection = {
    selectedRowKeys: selectItems.selectedRowKeys || [],
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectItems.selectedRowKeys.length > selectedRowKeys.length) {//取消
        const filter_id = selectItems.selectedRowKeys.filter(item => !selectedRowKeys.includes(item.id));
        const filterBaseList = baseList.filter(item => !filter_id.includes(item.id));
        setBaseList(filterBaseList);
      }
      setSelectItems({ selectedRowKeys, selectedRows });
    },
    getCheckboxProps: (record) => ({
      disabled: !record.add_cart,
    }),
  };
  const addToCart = async () => {
    const { type, often_id } = props;
    const { selectedRows = [] } = selectItems;
    const result = {
      cart: async () => inventoryAddList({ data: [...baseList, ...selectedRows] }),
      often: async () => inventoryAddOftenList({ data: [...baseList, ...selectedRows], id: often_id }),
    };
    const { data: { code, msg } } = await result[type]() || {};
    if (+code === 0) {
      message.success(msg);
      props.refresh();
    } else {
      message.error(msg);
    }
  };
  const openModalVisible = () => setModalVisible(true);
  const closeModalVisible = () => setModalVisible(false);
  const deleteItem = id => {
    const filterBaseList = baseList.filter(item => item.id !== id);
    const selectedRows = selectItems.selectedRows.filter(item => item.id !== id);
    const selectedRowKeys = selectedRows.map(item => item.id);
    setBaseList(filterBaseList);
    setSelectItems({ selectedRows, selectedRowKeys });
  };
  const calcList = () => {
    const res = new Map();
    return [...baseList, ...selectItems.selectedRows].filter((item) => !res.has(item['id']) && res.set(item['id'], 1));
  };
  return (
    <>
      <div className='cart-form' style={{ minHeight: 500 }}>
        <Form className='cart-form-search' size='small' form={form} name="cartForm"  {...layout} onFinish={onFinish}>
          <Row>
            <Col span={8}><Form.Item name="sku_no" label='SKU编码' className='cart-form-label'><Input placeholder="" /></Form.Item></Col>
            <Col span={8}><Form.Item name="sku_name" label='商品名称' className='cart-form-label'><Input placeholder="" /></Form.Item></Col>
            <Col span={8}>
              <Form.Item name="category_id" label='商品分类：' className='cart-form-label'>
                <TreeSelect
                  treeData={(props?.categoryList || [])}
                  maxTagCount={2}
                  showSearch
                  style={{ width: '100%', }}
                  treeDataSimpleMode
                  fieldNames={{ label: 'name', value: 'id', children: 'children' }}
                  dropdownStyle={{ maxHeight: 200, overflow: 'auto', }}
                  placeholder=""
                  allowClear
                  multiple
                  filterTreeNode={(inputValue, treeNode) => treeNode.name.includes(inputValue)}
                ></TreeSelect>
              </Form.Item>
            </Col>
            <Col span={8}><Form.Item name="erp_code" label='RMS编码' className='cart-form-label'><Input placeholder="" /></Form.Item></Col>
            <Col span={13}><Form.Item name="supplier_id" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} label='大仓名称：' className='cart-form-label'><Select placeholder="">{suppliersList.map(item => <Option value={item.company_id} key={item.company_id} >{item.company.name}</Option>)}</Select></Form.Item></Col>
            {/* <Col span={8}><Form.Item name="brand_id" label='品牌：' className='cart-form-label'><Select placeholder="">{(props?.brandList || []).map(item => <Option value={item.id} key={item.id}>{item.name}</Option>)}</Select></Form.Item></Col> */}
            <Col span={8} offset={16} style={{ textAlign: 'right' }}><Button type='primary' htmlType='submit'>搜索</Button><Button style={{ marginLeft: 8 }} onClick={onReset}>重置</Button><Button disabled={!calcList([...baseList, ...selectItems.selectedRows]).length} style={{ marginLeft: 8 }} onClick={openModalVisible} type='primary'>确认添加</Button></Col>
          </Row>
        </Form>
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey='sale_id'
          locale={{ emptyText: '未搜索到商品' }}
          rowSelection={rowSelection}
          scroll={{ y: 300, }}
          pagination={{
            showSizeChanger: true,
            pageSize: pageConfig.page_size,
            total: totalPage,
            current: pageConfig.page,
            onChange: tablePageChange,
            onShowSizeChange: (current, pageSize) => tablePageChange(pageSize, current),
          }} />
      </div>
      <Modal title='加购商品清单' open={modalVisible} destroyOnClose width={1000} centered onCancel={closeModalVisible} getContainer={false} okText='确认' onOk={addToCart}>
        <Table
          columns={addCartColumns}
          dataSource={calcList([...baseList, ...selectItems.selectedRows])}
          rowKey='sale_id'
          locale={{ emptyText: '暂无加购商品清单！' }}
          scroll={{ y: 300, }}
          pagination={false} />
      </Modal>
    </>
  );
});